import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import Honest from "@/components/site/Honest";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="font-body bg-white text-[#09090B]">
      <Nav />
      <Hero />
      <LogoMarquee />
      <Services />
      <HowItWorks />
      <Honest />
      <Testimonials />
      <Pricing />
      <FAQ />
      <LeadForm />
      <Footer />
    </main>
  );
}
